import React from 'react';

import { AppBar, Button, Toolbar, Typography } from '@mui/material';

import { useAuth } from '../../../services/auth/AuthContext';

const Header = () => {
  const { logout } = useAuth();
  const handleLogout = () => {
    logout();
  };
  return (
    <AppBar position="static" sx={{ height: '57px' }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          CJ Brothers Data Portal
        </Typography>

        {
          <Button color="inherit" onClick={handleLogout}>
            Log Out
          </Button>
        }
      </Toolbar>
    </AppBar>
  );
};

export default Header;
